import { render, staticRenderFns } from "./IndexMenu.vue?vue&type=template&id=b53de7c4&scoped=true&"
import script from "./IndexMenu.vue?vue&type=script&lang=js&"
export * from "./IndexMenu.vue?vue&type=script&lang=js&"
import style0 from "./IndexMenu.vue?vue&type=style&index=0&id=b53de7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53de7c4",
  null
  
)

export default component.exports